/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import styled, { withTheme } from 'styled-components'
import Icon from './Icon'
import httpRequest, { NETWORKS, savedNetwork } from '../../utils/httpRequest'
import { refresh, isMobile } from '../../utils/bomUtils'
import isElectron from '../../utils/isElectron'

const Wrapper = styled.div`
  display: flex;
  position: relative;
  color: ${({ theme }) => theme.up};
  font-size: 12px;
  height: 14px;
  line-height: 20px;
  align-items: center;
  cursor: pointer;
  .dropdown {
    transition: transform 0.3s ease-in;
  }
  &:hover {
    ul {
      display: block;
      li {
        position: relative;
      }
    }
    .dropdown {
      transform: rotate(180deg);
    }
  }

  &:after {
    content: ' ';
    position: absolute;
    height: 30px;
    width: 100%;
    top: 10px;
  }

  @media (max-width: 768px) {
    color: #fff;
    font-size: 16px;
    &:hover {
      ul {
        display: none;
      }
    }
  }
`

export const Cycle = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ theme }) => theme.up};
  margin-right: 5px;
`

const Accelerate = styled.ul`
  position: absolute;
  left: 0;
  top: 20px;
  background: ${({ theme }) => theme.dropdownBg};
  display: none;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  @keyframes appear {
    0% {
      height: 0;
      opacity: 0;
    }
    40% {
      height: 17px;
      opacity: 0;
    }
    100% {
      height: 34px;
      opacity: 1;
    }
  }
  &:before {
    content: ' ';
    position: absolute;
    width: 0;
    height: 0;
    border-width: 0 10px 10px;
    border-style: solid;
    border-color: transparent transparent rgba(33, 40, 51, 1);
    top: -6px;
    z-index: -1;
    left: 75px;
  }
  li {
    display: flex;
    padding: 10px 15px;
    font-size: 13px;
    width: 220px;
    animation: appear 0.2s ease-in-out;
    background: ${({ theme }) => theme.dropdownBg};
    .cycle {
      background: #48515d;
      margin-top: 2px;
    }
    .name {
      line-height: 10px;
      margin-left: 3px;
      color: ${({ theme }) => theme.dropdownItemColor};
    }
    .url {
      color: #848e9c;
      margin-left: 3px;
      margin-top: 5px;
      white-space: nowrap;
    }
    &:hover {
      background: ${({ theme }) => theme.dropdownSelectBgColor};
      color: ${({ theme }) => theme.highlight};
      .name {
        color: ${({ theme }) => theme.highlight};
      }
      .cycle {
        background: ${({ theme }) => theme.highlight};
      }
    }
    &.on {
      background-color: ${({ theme }) => theme.dropdownSelectBgColor};
      .cycle {
        background: ${({ theme }) => theme.up};
      }
      .name {
        color: ${({ theme }) => theme.up};
      }
    }
  }
`

const MobileWrap = styled.div`
  color: ${({ theme }) => theme.fontColor || 'black'};
  min-width: 250px;
  max-width: 450px;
  padding: 15px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.popupBg || '#fff'};
  box-shadow: ${({ theme }) => theme.boxShadow};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: ${({ hide }) => (hide ? 'translate(-50%, -250%)' : 'translate(-50%, -50%)')};
  transition: transform 0.3s ease;
  border-radius: 3px;

  @keyframes networkSlideUp {
    0% {
      transform: translate(-50%, -250%);
    }
    40% {
      transform: translate(-50%, -100%);
    }
    100% {
      transform: translate(-50%, -50%);
    }
  }
`

const AccelerateMobile = styled(Accelerate)`
  display: block;
  position: relative;
  left: 0;
  top: 0;
  background: transparent;
  box-shadow: none;
  li {
    margin-bottom: 10px;
    font-size: 16px;
    width: 260px;
    position: relative;
    .url {
      line-height: 30px;
    }
    @media (max-width: 320px) {
      width: 240px;
      font-size: 14px;
    }
  }
`

const Close = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
  color: #848e9c;
  line-height: 20px;
  &:hover {
    color: ${({ theme }) => theme.highlight};
  }
`

const Latency = styled.div`
  position: absolute;
  right: 10px;
  top: 5px;
  color: ${props => props.color};
  font-family: 'DINNext';
`

export const getNodeText = current =>
  `Accelerated ${NETWORKS.indexOf(current) === -1 ? 1 : NETWORKS.indexOf(current) + 1}`

class NetWork extends React.Component {
  static propTypes = {
    close: PropTypes.func,
  }

  static defaultProps = {
    close: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      current: savedNetwork || NETWORKS[0],
      hide: false,
      apiLatency: {},
    }
  }

  componentDidMount() {
    this._pingNode()
  }

  _pingNode() {
    const apiLatency = {}
    let pingTime = 200000
    let node = NETWORKS[0]
    NETWORKS.forEach(async (network, index) => {
      const startTime = new Date().getTime()
      let endTime
      let diff
      //Catch the api error.
      try {
        await httpRequest.ping(`https://${network}`)
        endTime = new Date().getTime()
        diff = endTime - startTime
      } catch (err) {
        diff = 'error'
      }

      apiLatency[network] = diff
      this.setState({ apiLatency })
      if (diff < pingTime) {
        pingTime = diff
        node = savedNetwork || network
      }

      if (index === NETWORKS.length - 1) {
        httpRequest.setBaseUri(node)
        this.setState({ current: node })
      }
    })
  }

  _selectNetwork = network => {
    this.setState({ current: network }, () => {
      window.sessionStorage.setItem('network', network)
      if (isElectron()) {
        const ipcRenderer = window.ipcRenderer
        ipcRenderer.send('reload')
      } else {
        refresh()
      }
    })
  }

  _close = () => {
    const { close } = this.props
    this.setState({ hide: true }, () => {
      setTimeout(() => {
        close()
      }, 300)
    })
  }

  render() {
    const { theme } = this.props
    const { current, hide, apiLatency } = this.state
    const networkText = getNodeText(current)
    const siteOpts = NETWORKS.map((network, index) => {
      let color = theme.up
      const traffic = apiLatency[network]
      if (traffic > 1000 && traffic < 2000) {
        color = theme.highlight
      }

      if (traffic >= 2000) {
        color = theme.down
      }

      if (traffic === 'error') {
        color = theme.down
      }

      return (
        <li
          key={index}
          className={current === network ? 'on' : ''}
          onClick={() => {
            this._selectNetwork(network, index)
          }}
        >
          <Cycle className="cycle" />
          <div>
            <div className="name">{`Accelerated ${index + 1}`}</div>
            <div className="url">{network}</div>
          </div>
          <Latency color={color}>
            {traffic === 'error' ? 'Network Issue' : `${traffic || 0} ms`}
          </Latency>
        </li>
      )
    })
    return (
      <>
        {!isMobile() ? (
          <Wrapper>
            <Cycle />
            <span>{networkText}</span>
            &nbsp;&nbsp;
            <span className="dropdown">▾</span>
            <Accelerate>{siteOpts}</Accelerate>
          </Wrapper>
        ) : (
          <MobileWrap hide={hide}>
            <AccelerateMobile>{siteOpts}</AccelerateMobile>
            <Close onClick={this._close}>
              <Icon type="close" />
            </Close>
          </MobileWrap>
        )}
      </>
    )
  }
}

export default withTheme(NetWork)
